<template>
    <div class="examHeader">
        <img
            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试报名背景.png"
            v-if="activeRouter === 'registration'"
            alt=""
            class="pcbg"
        />
        <img
            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试背景移动.png"
            v-if="activeRouter === 'registration'"
            alt=""
            class="pcbg mbg"
        />
        <img
            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试订单.png"
            v-if="activeRouter === 'order' || activeRouter === 'appealReconsideration'|| activeRouter === 'appealReconsiderationList'"
            alt=""
            class="pcbg"
        />
        <img
            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试订单移动.png"
            v-if="activeRouter === 'order'|| activeRouter === 'appealReconsideration' || activeRouter === 'appealReconsiderationList'"
            alt=""
            class="pcbg mbg"
        />
        <div class="page-text">
            {{
                activeRouter === "registration"
                    ? $t("index.mainTitle")
                    : activeRouter === "order"
                    ? $t("mine.myTests")
                    : activeRouter === "appealReconsiderationList" ? $t("resultsReview.title")  : ""
            }}
            <div class="top-content5" @click="goAppealReconsideration" v-if="activeRouter === 'appealReconsiderationList'">
                {{ $t("resultsReview.requestReview") }} 
                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/detail1.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import LoginPage from "@/components/LoginPage.vue";

export default Vue.extend({
    components: { LoginPage },
    data() {
        return {
            activeRouter: null,
            title: "",
        };
    },
    watch: {
        $route: function (to, from) {
            this.activeRouter = to.meta.type;
        },
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                if (this.currentLocale === "zh-CN") {
                    this.activeRouter === "registration"
                        ? "考试报名"
                        : activeRouter === "order"
                        ? "考试订单"
                        : "";
                } else {
                    this.activeRouter === "registration"
                        ? "考试报名"
                        : activeRouter === "order"
                        ? "考试订单"
                        : "";
                }
            },
        },
    },
    mounted() {
        this.activeRouter = this.$route.meta.type;
    },
    methods: {
        goAppealReconsideration() {
            this.$router.push({
                name: "appealReconsideration",
            });
        }
    },
    beforeDestroy() {},
});
</script>
<style lang="stylus" scoped>
.examHeader {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    position: relative;
    img {
        // width: 100%;
        height: 240px;
    }
    .mbg {
        display: none;
    }

    .pcbg {
        width: 100%;
        // height: 300px;
    }

    .page-text {
        font-weight: bold;
        font-size: 40px;
        color: #FFFFFF;
        position: absolute;
    }
}
  .top-content5 {
    // width: 200px;
    width: fit-content;
    height: 50px;
    padding: 0 20px;
    border-radius: 38px;
    line-height: 74px;
    background: #0043E0;
    border-radius: 36px;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    transition: transform 0.3s ease;
    cursor: pointer;
    background: #00AE8F;
}

.top-content5 img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-left: 26px;
}

.top-content5:hover {
    transform: translateY(-5px);
}


/* 手机类 */
@media (max-width: 640px) {
    .examHeader {
        .pcbg {
            display: none;
        }

        .mbg {
            display: block;
            width: 100%;
            // height: 300px;
        }
        img {
            height: 18vh
        }
    }
     .top-content5 {
            width: 46vw;
            height: 10.8vw;
            line-height: 10.8vw;
            font-size: 3.6vw;
            margin: 6vw auto;
            border-radius: 6vw;
            img {
                width: 5.8vw;
                height: 5.8vw;
                margin-left: 4vw;
            }
        }
        .top-content5 {
            background: #00ae8f;
        }
}
</style>
